import type { HTMLAttributes } from "react";
import { cn } from "../../lib/utils";

export function Badge({ className, ...props }: HTMLAttributes<HTMLSpanElement>) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border border-[var(--line)] bg-[var(--surface-elevated)] px-2.5 py-1 text-xs font-semibold text-[var(--muted-foreground)]",
        className,
      )}
      {...props}
    />
  );
}

